import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=2bf68958&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=2bf68958&prod&scoped=true&lang=css"
import style1 from "./Registration.vue?vue&type=style&index=1&id=2bf68958&prod&lang=less&scoped=true"
import style2 from "./Registration.vue?vue&type=style&index=2&id=2bf68958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf68958",
  null
  
)

export default component.exports